import { Tooltip } from '@monorepo/shared/componentsV2/Tooltip';
import truncate from 'lodash.truncate';
import React from 'react';
import { ColumnIconFactory } from '@monorepo/logs/src/components/ColumnIconFactory';
import styled from 'styled-components';
import { DisplayQueryColumn } from '@monorepo/shared/componentsV2/QueryResultsTable/resultsMapper';

const StyledColumnIcon = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.5rem;

  & svg {
    width: 0.9rem;
    height: 0.9rem;
    fill: ${({ theme }) => theme.colors.gray666} !important;
  }
`;

function getDisplayColumnLabel(column: DisplayQueryColumn) {
  return column.columnLabel.trim() || column.originalColumnLabel || '';
}

const MAX_COLUMN_LABEL_LENGTH = 30;
export function TruncatedColumnLabel({
  children,
  column,
  tooltipOffset,
  showIcon,
}: {
  children?: React.ReactNode;
  column: DisplayQueryColumn;
  tooltipOffset?: number;
  showIcon?: boolean;
}) {
  const columnLabel = getDisplayColumnLabel(column);
  const shouldTruncate = columnLabel.length > MAX_COLUMN_LABEL_LENGTH;
  return shouldTruncate ? (
    <Tooltip
      offset={tooltipOffset}
      placement="left"
      tabIndex={0}
      title={columnLabel}
    >
      <span>
        {showIcon && (
          <StyledColumnIcon>
            <ColumnIconFactory fieldIconType={column.fieldIconType} />
          </StyledColumnIcon>
        )}
        {truncate(columnLabel, { length: MAX_COLUMN_LABEL_LENGTH })}
        {children}
      </span>
    </Tooltip>
  ) : (
    <>
      {showIcon && (
        <StyledColumnIcon>
          <ColumnIconFactory fieldIconType={column.fieldIconType} />
        </StyledColumnIcon>
      )}
      {columnLabel}
      {children}
    </>
  );
}
